// extracted by mini-css-extract-plugin
export default {"input":"Component_input__vXEhO","loader":"Component_loader__AJRmP","fade":"Component_fade__5EIdM"};